import React from 'react';
import Header from './Header';
import Looks from './Looks';
import Footer from './Footer';
import * as S from './styles';

const Main: React.FC = () => {
  return (
    <S.Container>
      <Header />
      <S.Content>
        <S.Sponsor
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          PATROCINADO POR
          <br />
          VOGUE EYEWEAR
        </S.Sponsor>
        <S.Text
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          <S.Title>
            A leitura do currículo de Manu Gavassi exige certo fôlego.
            Integrante célebre da geração millennial, ela nasceu em 1993 e,
            desde então, procura incansavelmente encontrar seu lugar no planeta.
            É exatamente por transitar em múltiplos universos criativos que Manu
            se tornou a nova embaixadora da Vogue Eyewear.
          </S.Title>
          <p>
            A marca, conhecida por seus óculos cheios de personalidade, buscava
            um nome que representasse estilo genuíno e ousadia criativa. Ninguém
            resume tudo isso melhor do que a popstar brasileira, que já havia
            colaborado com eles no clipe de "sub.ver.si.va". No vídeo, todos os
            personagens ostentam armações icônicas da empresa italiana. Aliás, a
            campanha deste ano, é claro, tem Manu Gavassi nos créditos. E não
            apenas do elenco. Ela assina direção e roteiro também.
          </p>
          <p>
            Na Wikipédia da paulistana Manoela Latini Gavassi Francisco, lê-se
            que ela é cantora, compositora, atriz, dubladora, apresentadora,
            escritora, diretora, produtora, roteirista e influenciadora digital.
            Ufa! A cada pitstop, ela registra os fatos e sentimentos e os revela
            para o mundo à sua maneira. Daí surgem as mil facetas que compõem
            esse CV estrelado.
          </p>
          <p>
            Nas redes sociais – onde Manu dá as caras desde os 14 anos por meio
            de cinco perfis profissionais no Orkut –, vimos muitas de suas
            versões. Já foi ídolo teen para uma galera que, hoje, não é mais
            teen. Foi a garota da headband na revista <i>Capricho</i>, a "garota
            errada" no YouTube, a "fofinha, mas louca" do disco{' '}
            <i>Cute, but psycho</i> (2018), a ex-BBB mais fashionista que
            tivemos e, mais recentemente, ela declarou estar cansada de fazer
            "gracinha" em seu último LP, lançado como um álbum visual e
            disponível exclusivamente no Disney+ desde novembro do ano passado.
          </p>
          <S.InnerPhotoWrapper
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
          >
            <S.Photo2 />
          </S.InnerPhotoWrapper>
          <p>
            Essa pluralidade é a razão por trás das quatro capas de ELLE View
            com Manu. Uma só não daria conta das tantas que moram ali dentro.
            Para tentar enxergar o mundo por suas lentes, marcamos uma conversa
            transatlântica. Via Zoom e diretamente do café da Fondazione Prada,
            em Milão, desenhado pelo diretor de cinema Wes Anderson, ela contou
            porque é apaixonada pela personagem Lexi (Maude Apatow), de{' '}
            <i>Euphoria</i>, da HBO, revelou sua fascinação pelo também
            multitalentos Donald Glover, contou tudo sobre a tour "Eu só queria
            ser normal" – com ingressos quase esgotados – e sobre a série da
            Netflix <i>Maldivas</i>, que estrela ao lado de Bruna Marquezine e
            estreia no dia 15 do próximo mês.
          </p>
        </S.Text>
      </S.Content>
      <S.Wrapper>
        <S.DoblePhotoWrapper
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          <div className="wrapper">
            <S.Photo3_1 />
          </div>
          <S.Photo3_2 />
        </S.DoblePhotoWrapper>
      </S.Wrapper>
      <S.Content>
        <S.Text
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          <h3>
            Sei que você gostou bastante de <i>Euphoria</i> e que se identifica
            com a personagem da Maude Apatow, a Lexi. O que vocês têm em comum?
          </h3>
          <p>
            Pois é. Eu fiquei muito feliz com o destaque que ela ganhou na
            segunda temporada. E esse jeito de ela trabalhar, colocando a vida
            pessoal em pauta no trabalho artístico, é também o único jeito que
            eu sei fazer minhas coisas. Quando não posso criar dessa forma,
            sinto que o resultado fica mais genérico e não tem o mesmo efeito.
            Acho que quem gosta de mim, inclusive, espera isso do meu trabalho.
          </p>
          <h3>
            Tem uma frase do escritor estadunidense Jonathan Franzen em que ele
            diz: “A arte precisa do comprometimento do artista, precisa
            colocá-lo em uma posição desconfortável”. Você concorda com isso?
          </h3>
          <p>
            Completamente. Na música, é onde isso fica mais evidente, mas vale
            para tudo. O que eu escrevi nos vídeos de <i>Garota errada</i> –
            isso muito antes do <i>BBB</i> – foram assuntos comprometedores para
            mim. Eu estava me criticando e questionando tudo ao meu redor.
            Então, é claro que muitas pessoas ficaram até ofendidas com o que eu
            disse ali. No clipe de “Deve ser difícil dormir sem mim”, todo o
            plot é desenvolvido em cima de uma crítica ao mercado da música pop.
            Então, quer dizer que para fazer sucesso tem que estar pelada? Tem
            que ter <i>featuring?</i> E, claro, já ocorreu de uma pessoa ou
            outra não gostar do que escrevi em alguma letra me referindo a ela.
            É o que pode acontecer quando você fala da sua visão de mundo. Acho
            que para ser escritora, compositora, roteirista, criadora, qualquer
            coisa nesse sentido, precisa ter coragem. Afinal de contas, quanto
            mais gente te olhando, maior a possibilidade de você ser odiada.
          </p>
          <h3>
            Você já falou sobre a dificuldade em fazer shows, que é o tipo de
            coisa que a tira da sua zona de conforto. De onde vem a coragem para
            enfrentar a primeira grande turnê?
          </h3>
          <p>
            Já adianto que você está falando com uma Manu Gavassi em um período
            de profundos questionamentos. Estou tentando enfrentar os meus medos
            de frente. Vou fazer 30 anos em breve e acho que isso catapultou uma
            série de reflexões importantes. Eu me sinto muito protegida no
            estúdio. Se errou, pode gravar de novo, não tem problema. No show,
            isso é muito diferente. O controle que eu tenho da narrativa tem um
            limite. Não me sinto confortável nessa posição. O que é um pouco
            irônico porque passei três meses em uma casa televisionada em rede
            nacional. Mas são duas coisas diferentes. Ali, eu não estava cara a
            cara com o público, não sabia nada do mundo de fora. No show, as
            pessoas estão na sua frente. Fora isso, eu não sou uma artista que
            teve tanto contato com os palcos. Com a pandemia, acho que a gente
            passou a se relacionar com esse tipo de coisa de uma maneira muito
            diferente. Cheguei, inclusive, a questionar se deveria ou não
            continuar com esse projeto. No final, decidi encarar esse medo.
            Minha missão é fazer disso uma experiência divertida, tanto para
            quem me assiste quanto para mim mesma. Tem sido um processo muito
            bonito e muito novo.
          </p>
          <h3>
            Sua turnê se chama <i>Eu só queria ser normal</i>, trecho da música
            “Áudio de desculpas”. O que é ser normal para Manu Gavassi?
          </h3>
          <p>
            Quando escrevi a letra da música, eu estava falando sobre
            sentimentos. Sou maluca e visceral em relação ao que eu sinto. Sou
            uma pessoa que pensa muito. Por um lado, isso é ótimo para minha
            profissão. Por outro, eu me pego insegura em alguns momentos por
            tentar racionalizar demais coisas que não têm tanta lógica. Ainda
            assim, quando coloco tudo na balança, acho que essa é uma maluquice
            que vale a pena. É a ela que devo minha criatividade. Acho que,
            nessa música, o que eu queria dizer era: “Está tudo bem ser normal
            de vez em quando. Pode relaxar um pouco, não precisa ser tão dura
            consigo mesma”.
          </p>
          <h3>
            De certa forma, a sua vida é bem pouco normal mesmo. A fama chegou
            muito cedo para você e a gente sabe o tamanho do estrago que ela
            pode causar em uma adolescente. Como conseguiu contornar as
            armadilhas dessa trajetória?
          </h3>
          <p>
            Agora, mais velha, depois de tudo que já passou – desde meus 14
            anos, quando comecei a compor, até o <i>BBB</i>, que me deu uma
            projeção muito diferente –, sinto que foi a minha família que me
            manteve com os pés no chão. Tenho a sorte de ter uma família muito
            legal, que em nenhum momento deixou que eu me sentisse maior ou
            menor do que qualquer pessoa por causa da minha profissão. Hoje eu
            tenho também um namorado que soma muito. Ele é muito tranquilo,
            muito verdadeiro e sempre me fala: “É estranho pensar que você é
            famosa”, e eu concordo. Acho que o lado ruim é que a gente fica mais
            medroso mesmo. Quando tem muita gente te olhando, pode ser que
            apontem o dedo para verdades ou questões com as quais você ainda não
            entendeu como lidar. É isso. As pessoas que estão ao meu redor me
            salvaram e continuam me salvando.
          </p>
        </S.Text>
      </S.Content>
      <S.Wrapper>
        <S.DoblePhotoWrapper
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          <div className="wrapper">
            <S.Photo4_1 />
          </div>
          <S.Photo4_2 />
        </S.DoblePhotoWrapper>
      </S.Wrapper>
      <S.Content>
        <S.Text
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          <h3>
            A Alanis Morissette, de quem você é fã, tem uma história bem
            diferente nesse sentido, muito mais conturbada. Por que o disco{' '}
            <i>Jagged little pill</i> (1995) mexe tanto com você?
          </h3>
          <p>
            Cara, eu descobri esse disco muito depois do lançamento, porque eu
            era pirralha na época. Foi uma descoberta depois da minha
            adolescência. Eu amei o jeito que ela se expressava e se expunha nas
            letras! E eu sempre me identifiquei com essa postura, porque era o
            que eu fazia desde muito novinha. Por isso, via muito valor. Até
            hoje, as cantoras e compositoras que escrevem a respeito delas
            mesmas e da vida delas são aquelas com que eu mais me identifico. O
            que mais me toca é o discurso, é letra. Sou uma pessoa de palavras.
            Seja em uma série, seja em alguém da internet que se comunica muito
            bem e que eu goste, seja em um podcast ou em uma música. Então,
            quando eu descobri a Alanis, eu achei tão poderoso! E vi também que
            a voz dela tinha uma força diferente, uma voz que ficava meio rouca
            no final do álbum e que isso aconteceu porque ela gravou tudo em um{' '}
            <i>take</i> só, como se fosse um show. Aquilo me marcou muito.
            Descobri o disco muito depois do lançamento, mas lembro que quando
            descobri fez muito sentido pra mim. E pensei: “Esse é o tipo de
            artista que eu quero ser”, não importa em qual lugar eu esteja
            atuando.
          </p>
          <h3>Fora Alanis, quem mais a inspira hoje?</h3>
          <p>
            Olha, o Donald Glover é meu grande ídolo no momento. Fico muito
            impressionada com tudo o que ele faz. Gosto muito da série dele,{' '}
            <i>Atlanta</i>, e do quanto ele se permite experimentar nela. Quando
            descobri que ele também era o Childish Gambino (nome do projeto
            musical de Glover), fiquei ainda mais chocada. Ele fez história com
            “This is America”. Não sei se muitas pessoas sabem disso, mas o meu
            álbum visual <i>Gracinha</i> se inspirou muito em{' '}
            <i>Guava Island</i>. Acho que ele conseguiu ser simples e mágico ao
            mesmo tempo nesse projeto, ao amarrar as músicas com uma narrativa,
            uma história a ser contada. Também sou louca pela Phoebe{' '}
            <i>Waller-Bridge</i>, de <i>Fleabag</i>. Acho incrível como ela
            escreveu tudo aquilo e ainda protagonizou a série. É um caso
            parecido com o da Michaela Coel, de <i>I may destroy you</i>. Ela
            foi genial na maneira como colocou a sua própria história em pauta.
            Acho que as pessoas que me inspiram hoje têm duas características
            muito fortes em seu trabalho: a falta de medo de se expor, de se
            abrir, e a vontade de trabalhar em mais de uma área de criação.
            Gosto muito de quem “faz tudo ao mesmo tempo”. Esse é um caminho que
            eu também quero percorrer. O que também pode ser um pouco exaustivo.
            Confesso que, de vez em quando, eu queria que o telefone tocasse com
            um job bem direto e objetivo e eu pudesse só dizer sim e ir lá
            fazer.
          </p>
          <S.InnerPhotoWrapper>
            <S.Photo5
              className="wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
            />
          </S.InnerPhotoWrapper>
          <h3>
            Estamos bem perto do lançamento de <i>Maldivas</i>, série que tem
            você, Bruna Marquezine e várias outras estrelas no elenco. O que
            você pode adiantar para a gente do projeto?
          </h3>
          <p>
            E não é que <i>Maldivas</i> foi um bom exemplo de quando o telefone
            tocou desse jeito? <i>(risos)</i> Não acontece muito, então fiquei
            superanimada para fazer. Foi a primeira coisa que aceitei logo
            depois de sair do <i>BBB</i>. Eu amo a roteirista responsável pela
            série, que é a Natalia Klein. Já era fã dela havia algum tempo,
            antes de ser convidada para <i>Maldivas</i>. Foi um processo bem
            longo porque aconteceu durante a pandemia. Tivemos que parar de
            gravar em um dado momento e voltamos depois. Minha personagem é a
            síndica de um prédio que se chama Maldivas. É uma dondoca que acha
            que as reuniões do condomínio são o evento mais importante do mundo.
            Ela se leva muito a sério e ama essa função, que, em geral, todo
            mundo despreza. E essa seriedade toda, em alguma medida, também
            disfarça uma vida muito infeliz, sem independência, subjugada ao
            marido, vivido pelo Klebber Toledo. Ainda que seja uma série de
            comédia, as nuances são muito legais. Quando li o roteiro, pensei:
            “Cara, essa é minha chance de provar que eu sou atriz!”{' '}
            <i>(risos)</i> Estou muito feliz que a estreia esteja chegando e que
            finalmente o público vá conhecer essas personagens.
          </p>
          <h3>Como a moda te ajuda a encontrar essas suas tantas facetas?</h3>
          <p>
            Desde muito nova, a moda já era uma ferramenta para mim nesse
            sentido. Na escola, eu me vestia toda louca, bem diferente de todo
            mundo. Até sofri bullying por isso. O legal foi que eu aprendi a me
            ver bonita quando eu estava diferente. Acho que sempre foi, para
            mim, uma maneira de me afirmar, de mostrar que eu tenho a minha
            própria personalidade, que não sou muito normal. Porque, na verdade,
            acho que a moda acaba revelando um pouco para o mundo quem nós
            somos. Inclusive, nesse momento, eu estou meio exausta da moda…
            <i>(risos)</i> Sinto que meu maior desafio agora é me enxergar sem
            todos esses adornos. Quem sou eu por baixo de tudo isso? Qual é o
            meu estilo de verdade? Aliás, o básico hoje anda tão diferente, né?
            Em um mundo onde ninguém quer ser básico, tenho achado legal ficar
            nesse lugar por um tempo. Hoje, por exemplo, estou usando uma
            camiseta do meu namorado, que ele provavelmente comprou em alguma
            feirinha por aqui. Agora, no meu trabalho artístico, a coisa muda de
            figura. No álbum visual, a moda tinha uma função muito específica.
            Ela ajudava a contar a história. É uma coisa totalmente diferente do
            que eu tenho vestido no dia a dia.
          </p>
        </S.Text>
      </S.Content>
      <S.Wrapper>
        <S.DoblePhotoWrapper
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          <div className="wrapper">
            <S.Photo6_1 />
          </div>
          <S.Photo6_2 />
        </S.DoblePhotoWrapper>
      </S.Wrapper>
      <S.Content>
        <S.Text
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          <h3>
            Falando sobre voltar para o básico, fazer a transição capilar tem a
            ver com isso também?
          </h3>
          <p>
            Acho que essa é uma das coisas mais difíceis que já fiz. Sempre fui
            uma menina de cabelo enrolado, mas comecei a alisar o cabelo muito
            cedo porque todo mundo me falava que não era bonito. Não tive
            exemplos na minha infância que me inspirassem no sentido contrário,
            e a mensagem que estava circulando sobre meu cabelo não era nada
            positiva. Obviamente, isso faz parte de uma triste herança do
            racismo no Brasil, e uma crueldade que se faz com meninas ao redor
            do país. O alisamento veio para mim junto com uma série de outros
            procedimentos estéticos, que eu fiz para me encaixar em um suposto
            padrão de beleza. Em janeiro, por exemplo, tirei o silicone que
            tinha nos seios. Acho que estou no momento perfeito para passar pela
            transição porque hoje sinto que confio em mim mesma. Se por um
            momento eu olhar para o espelho e não me reconhecer, tudo bem, isso
            não significa que sou menos linda. E, se eu descobrir que o cabelo
            natural não tem nada a ver comigo, eu posso alisar de novo. Estou
            tentando viver essa experiência do jeito mais leve possível. Para
            mim, é um ato de coragem em relação à minha autoestima e segurança.
          </p>
          <h3>
            E como fica a maquiagem nessa história? No <i>BBB</i>, suas
            produções ultracoloridas foram pauta nacional.
          </h3>
          <p>
            Quando eu estava lá, a maquiagem me salvou. <i>(risos)</i> Era
            divertido me arrumar, e eu amava! Aquilo me ajudava a manter o
            astral mais alto, a sobreviver. Gosto de pensar que fui uma
            personagem esquisita no programa. Até porque aquilo ali é uma
            experiência tão maluca, que é legal ter essas pequenas coisas para
            se apegar. Junto com as roupas, a maquiagem era uma grande fuga.
            Pintar um olho colorido era muito legal, me deixava mais feliz. No
            entanto, ao mesmo tempo que eu gosto muito de maquiagem, não dependo
            dela para me sentir bonita. Cada vez mais, venho usando menos,
            inclusive. Hoje eu gosto do que vejo quando olho no espelho.{' '}
          </p>
        </S.Text>
      </S.Content>
      <S.VideoWrapper
        className="wow animate__animated animate__fadeIn"
        data-wow-duration="1s"
      >
        <div className="vimeoWrapper">
          <iframe
            src="https://player.vimeo.com/video/713292401?h=abb9a9c3f5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="Vogue Eyewear_V6"
          ></iframe>
        </div>
        <script src="https://player.vimeo.com/api/player.js"></script>
      </S.VideoWrapper>
      <S.Content>
        <S.Text
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          <h3>
            Os óculos também teriam essa função? Eles ajudam você a se expressar
            de alguma forma?
          </h3>
          <p>
            Cara, eu sempre amei óculos! Quando criança, eu queria ter algum
            problema na visão para usar óculos de grau. <i>(risos)</i> Queria
            tanto que hoje tenho! <i>(risos)</i> Então, acredito ser também uma
            maneira de se expressar. É um acessório atemporal, sempre fez parte
            de mim e do meu estilo. Meus óculos sempre me acompanharam. Tenho
            uma coleção gigantesca deles.
          </p>
          <h3>
            Por fim, existe algum momento em que você olha para o que fez e se
            sente satisfeita?
          </h3>
          <p>
            Nossa, não existe! <i>(risos)</i> Não, calma… Acho que é algo que eu
            preciso trabalhar na terapia. Sou muito perfeccionista e muito
            radical. Ou as coisas estão exatamente como eu idealizei, ou eu as
            descarto. Tenho pouco meio-termo e, para quem trabalha com
            criatividade, isso é um problema. Não façam isso com vocês! Por
            outro lado, fico pensando que eu trabalhei tanto nos últimos anos:
            teve o <i>BBB</i>, fiz a série para a Netflix, criei campanhas para
            um monte de marcas. E, ainda assim, às vezes, as pessoas me dizem:
            “Nossa, como você anda sumida! Qual o próximo projeto?” Então, acho
            que a sociedade também acaba mandando essa mensagem. Talvez o meu
            maior desafio seja este, respeitar mais a minha trajetória. Ficar
            satisfeita com o que eu faço, confiar que eu sou boa no que pretendo
            fazer e que estou no meu caminho.{' '}
          </p>
        </S.Text>
      </S.Content>
      <Looks />
      <Footer />
    </S.Container>
  );
};

export { Main };
